import * as Preact from 'preact';
import { Box } from '@mui/material';
import * as CTACombo from '../M_CtaCombo';
import { SxProps } from '@mui/system';

export interface Props {
    sx?: SxProps;
    primary: CTACombo.Action;
    secondary?: CTACombo.Action;
}

export const Component = (p: Props) => {
    return (
        <Box
            sx={{
                padding: '16px',
                width: '100%',
                backgroundColor: 'background.paper',
                boxSizing: 'border-box',
                ...p.sx,
            }}
        >
            <CTACombo.Component primary={p.primary} secondary={p.secondary} />
        </Box>
    );
};

Component.displayName = 'ModalActionBar';
